import { render, staticRenderFns } from "./PagosGuardar.vue?vue&type=template&id=cf258a34"
import script from "./PagosGuardar.vue?vue&type=script&lang=js"
export * from "./PagosGuardar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports